// extracted by css-extract-rspack-plugin
var _1 = "PjlX8e0I70IkHSnt";
var _2 = "Q5spJG9ymABibuSU";
var _3 = "rv8kzb1IQxIRUv8A";
var _4 = "PjlX8e0I70IkHSnt";
var _5 = "Q5spJG9ymABibuSU";
var _6 = "rv8kzb1IQxIRUv8A";
var _7 = "DAIDGvyRgF0WCn0l";
var _8 = "zItb3dWtV5oOVrfe";
var _9 = "bA6wEx69Z473ArNh";
var _a = "zItb3dWtV5oOVrfe";
var _b = "bA6wEx69Z473ArNh";
var _c = "XW8R3Wsi3PIKHPcF";
var _d = "XW8R3Wsi3PIKHPcF";
var _e = "GO7f1mbpY49CoNGh";
var _f = "GO7f1mbpY49CoNGh";
var _10 = "RVsWiPl5QvAtXIQL";
var _11 = "fePJyG3kigMAx7Dl";
var _12 = "k3eHAFDDYeMdv1Pp";
var _13 = "fePJyG3kigMAx7Dl";
var _14 = "k3eHAFDDYeMdv1Pp";
var _15 = "WY38L0BSX8UEJTfe";
var _16 = "WY38L0BSX8UEJTfe";
var _17 = "Xn25gVih1C4elapZ";
export { _1 as "event-icon", _2 as "event-minute", _3 as "event-minute--injury-time", _4 as "eventIcon", _5 as "eventMinute", _6 as "eventMinuteInjuryTime", _7 as "header", _8 as "header--no-event", _9 as "header--with-injury", _a as "headerNoEvent", _b as "headerWithInjury", _c as "icon-container", _d as "iconContainer", _e as "is-draw", _f as "isDraw", _10 as "label", _11 as "pk-icon", _12 as "pk-icon--goal", _13 as "pkIcon", _14 as "pkIconGoal", _15 as "team-flag", _16 as "teamFlag", _17 as "time" }
